import { useCompleteActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost } from '@/api/generated-catch-backend/action-plan-interventions/action-plan-interventions';
import { queryClient } from '@/client/query';
import interventions from '@/repositories/interventions.repository';
import { useQuery } from '@tanstack/react-query';

const QUERY_KEY = ['interventions', 'get'] as const;

export function useInterventions() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: interventions.get,
  });
}

export function useCompleteInterventionMutation() {
  return useCompleteActionPlanInterventionV1ActionPlanInterventionsActionPlanInterventionIdPost({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: QUERY_KEY });
      },
    },
  });
}
